interface IBuildConfig {
    pixiPrefix: string;
    bgPrefix: string;
}

export enum BuildConfigTypes {
    WithSubPath,
    WithoutSubPath
}

export class BuildConfig {
    private static withSubPath: IBuildConfig = {
        pixiPrefix: '../../',
        bgPrefix: '../'
    };
    private static withoutSubPath: IBuildConfig = {
        pixiPrefix: '',
        bgPrefix: ''
    };

    public static currentConfigType: BuildConfigTypes = BuildConfigTypes.WithSubPath;

    public static getConfig(): IBuildConfig {
        const currentType = this.currentConfigType;
        switch (currentType) {
            case BuildConfigTypes.WithSubPath: {
                return this.withSubPath;
            }
            case BuildConfigTypes.WithoutSubPath: {
                return this.withoutSubPath;
            }
        }
    }
}
